import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { fComp } from '../../utils/React.js';
import { getThemeChildrenClass } from '../Theme/ThemePresentation.js';
import { mainClass } from './CardContainer.styles.js';

var CardContainerPresentation = fComp(function (_ref) {
  var _cleanupClassObject, _cleanupClassObject2, _cleanupClassObject3;
  var topArea = _ref.topArea,
    bottomArea = _ref.bottomArea,
    hasHover = _ref.hasHover,
    disabled = _ref.disabled,
    active = _ref.active,
    separator = _ref.separator,
    contentAlignment = _ref.contentAlignment,
    innerSpacing = _ref.innerSpacing;
  return /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, mainClass, true), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__has-hover"), hasHover && !disabled), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__disabled"), disabled), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__active"), active), _defineProperty(_cleanupClassObject, "".concat(mainClass, "__").concat(innerSpacing), innerSpacing), _defineProperty(_cleanupClassObject, getThemeChildrenClass("elevated"), true), _cleanupClassObject))
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(mainClass, "__before")
  }), /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject2 = {}, _defineProperty(_cleanupClassObject2, "".concat(mainClass, "-top-area"), true), _defineProperty(_cleanupClassObject2, "".concat(mainClass, "__").concat(contentAlignment), !!contentAlignment), _cleanupClassObject2))
  }, topArea), bottomArea && /*#__PURE__*/React.createElement("div", {
    className: cleanupClassObject((_cleanupClassObject3 = {}, _defineProperty(_cleanupClassObject3, "".concat(mainClass, "-bottom-area"), true), _defineProperty(_cleanupClassObject3, "".concat(mainClass, "-bottom-area__centered"), !!contentAlignment), _defineProperty(_cleanupClassObject3, "".concat(mainClass, "-bottom-area__separator"), !!separator), _cleanupClassObject3))
  }, bottomArea));
});
CardContainerPresentation.displayName = "CardContainerPresentation";

export { CardContainerPresentation };
